<template>
    <ComboboxInput
        v-bind="forwarded"
        :class="cn('ds-combobox-input', props.class)"
    >
        <slot />
    </ComboboxInput>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { ComboboxInputProps } from 'reka-ui';
import { ComboboxInput, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<ComboboxInputProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwarded = useForwardProps(delegatedProps);
</script>
